import { Market } from 'src/interfaces/market'
import { State } from '../reducers/types'

export const getMarkets = (state: State): Array<Market> => state.market.markets

export const getIsMarketsInitialized = (state: State): boolean => state.market.isMarketsInitialized

export const getSelectedMarket = (state: State): Market | null => {
  const markets = getMarkets(state)

  return markets.length > 1 ? state.market.selectedMarket : markets[0]
}
